import StudentCompetencySubcompetencyListActionTypes from '../actions/student-competency-subcompetency-list-action-types';

const initialState = {
  loading: false,
  studentCompetencySubcompetencies: null,
  studentCompetencySubcompetenciesCancelToken: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case StudentCompetencySubcompetencyListActionTypes.LOAD_STUDENT_COMPETENCY_SUBCOMPETENCY_LIST_START:
      return {
        ...state,
        loading: true
      };
    case StudentCompetencySubcompetencyListActionTypes.LOAD_STUDENT_COMPETENCY_SUBCOMPETENCY_LIST_END:
      return {
        ...state,
        studentCompetencySubcompetencies: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
